export function getTas() {
    if (window.tas && window.tas.isReady()) {
        return window.tas;
    }

    throw new Promise((resolve) => {
        window.addEventListener('tas.ready', resolve);
    });
}
